<template>
    <div class="product-add">
        <!--form表单-->
        <div class="common-form">活动类别设置</div>
        <el-form size="small" ref="form" :model="form" label-width="200px">
            <el-form-item
                    v-for="(item, index) in form.values.category"
                    :label="'类别' + (index + 1).toString()"
                    :key="item.key"
                    :prop="'values.category.' + index + '.name'"
                    :rules="{required: true, message: '字段不能为空', trigger: 'blur'}"
            >
                <el-input v-model="item.name" style="width: 200px" ></el-input><el-button @click.prevent="removeField(item)">删除</el-button>
            </el-form-item>

            <el-form-item>
                <el-button @click="addField">新增类别</el-button>
            </el-form-item>

            <el-form-item label="类型"
                          v-for="(item, index) in form.values.category"
                          :label="item.name"
                          :key="'type'+index.toString()"
            >
                <el-tag :key="index.toString() + item_index.toString()"
                        v-for="(item_value, item_index) in form.values.category[index].fields"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(index, item_index)">
                    {{item_value.name}}
                </el-tag>

                <el-button type="success" class="button-new-tag" size="small" @click="showInput(index)">+ 新增类别字段</el-button>

            </el-form-item>


            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="primary" @click="onSubmit" :loading="loading" v-auth="'/education/setting/index'" >提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { getSetting, setSetting } from '@/api/education'
    import Upload from "@/components/file/Upload";

    export default {
        name: 'activity-setting',
        components: {
            Upload
        },
        data() {
            return {
                /*form表单数据*/
                form: {
                    key: 'activity_fields',
                    describe: '活动扩展字段',
                    values: {
                        category: [
                            {name: '类别1', key: 1, fields: []}
                        ],
                    }
                },
                /*是否正在加载*/
                loading: true,
            };
        },
        props: {

        },
        created() {
            this.getSet()
        },
        methods: {
            //提交表单
            onSubmit() {
                this.loading = true;
                setSetting(this.form)
                    .then(data => {
                        this.loading = false;
                        this.$message({
                            message: '恭喜你，设置成功',
                            type: 'success'
                        });

                    })
                    .catch(error => {
                        this.loading = false;
                    });
            },
            removeField(item) {
                var index = this.form.values.category.indexOf(item)
                if (index !== -1) {
                    this.form.values.category.splice(index, 1)
                }
            },
            addField() {
                let length =  this.form.values.category.length
                this.form.values.category.push({
                    name: '',
                    key: parseInt(length) + 1,
                    fields: [],
                });
            },
            handleClose(index, tag_index) {
                this.form.values.category[index].fields.splice(tag_index, 1);
            },
            showInput(index) {
                this.$prompt('请输入字段', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.form.values.category[index].fields.push({
                        name: value,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                })
            },

            // 获取配置
            getSet(){
                getSetting({key: this.form.key}).then((result)=>{
                    if(result.data.values){
                        this.form.values = Object.assign(this.form.values, result.data.values)
                    }
                    this.loading = false;
                })
            },

        }
    };
</script>

<style>
    .tips {
        color: #ccc;
    }
    .el-tag + .el-tag {
        margin-left: 10px;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/activity/setting/index.vue